import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Grid)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

